import React from "react";
import Icon from "../../../components/UI/Icon/Icon";
import classes from "./Event.module.css";
import AbilityNames from "./AbilityNames";
import ItemDrops from "./ItemDrops";
import NatureName from "../../../Util/NatureName";
import MoveName from "../../../Util/MoveName";
import { useTranslation } from 'react-i18next';

const MonDetail = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);

    const moves = [props.data.Move0, props.data.Move1, props.data.Move2, props.data.Move3].reduce((prev, cur) => {
        if(cur === 0) {
            return prev;
        }
        return prev.concat(cur);
    }, []).map((v, idx) => {
        return <li key={idx}>{<MoveName id={v} />}</li>;
    })
    console.log(props.drops)
    return (
        <div className={classes.Entry}>
            <div className={classes.Center}><Icon details={props.data} /></div>
            <p><strong>Rarity: </strong></p>
            <ul>
                {props.data.Probabilities.map((i, idx) => {
                    return i > 0 ? <li key={idx}>{"☆".repeat(idx+1)}: {i}%</li> : null
                })}
            </ul>
            <p><strong>{t("LEVEL")}:</strong> {props.data.Level}</p>
            <p><strong>{t("DYNAMAXBOOST")}:</strong> {props.data.DynamaxBoost}x</p>
            <p><strong>{t("DYNAMAXLEVEL")}:</strong> {props.data.DynamaxLevel}</p>
            {props.data.ShieldLevel > 0 ? <p><strong>{t("DYNAMAXSHIELDLEVEL")}:</strong> {props.data.ShieldLevel}</p> : null}
            {props.data.ShieldPriority1 > 0 ? <>
                    <p><strong>{t("DYNAMAXSHIELDTHRESHOLD1")}:</strong> {props.data.ShieldThreshold1}%</p> 
                    <p><strong>{t("DYNAMAXEXTRAMOVE1")}:</strong> {<MoveName id={props.data.ShieldExtraMove1} />}</p> 
                    <p><strong>{t("DYANAMAXPRIOTY1")}:</strong> {t("DYNAMAXPRIO"+props.data.ShieldPriority1)}</p> 
                    </> : null
            }
            {props.data.ShieldPriority2 > 0 ? <>
                    <p><strong>{t("DYNAMAXSHIELDTHRESHOLD2")}:</strong> {props.data.ShieldThreshold2}%</p> 
                    <p><strong>{t("DYNAMAXEXTRAMOVE2")}:</strong> {<MoveName id={props.data.ShieldExtraMove2} />}</p> 
                    <p><strong>{t("DYANAMAXPRIOTY2")}:</strong> {t("DYNAMAXPRIO"+props.data.ShieldPriority2)}</p> 
                    </> : null
            }
            <p><strong>{t("FLAWLESSIVS")}:</strong> {props.data.FlawlessIVs}</p>
            <p><strong>{t("CATCHRATE_HOST")}:</strong> {t("CATCHRATE"+props.data.HostCatchRate)}</p>
            <p><strong>{t("CATCHRATE_OTHERS")}:</strong> {t("CATCHRATE"+props.data.OtherCatchRate)}</p>
            {props.data.ShinyForced ? <p><strong>{t("SHINY")}:</strong> {props.data.ShinyForced === 1 ? t("SHINYLOCKED") : t("SHINYFORCED")}</p> : null}
            <p><strong>{t("ABILITY")}:</strong></p><AbilityNames species={props.data.Species} altForm={props.data.AltForm} ability={props.data.Ability} />
            {props.data.Nature !== 25 ? <p><strong>{t("NATURE")}:</strong> {<NatureName id={props.data.Nature} />}</p> : null}
            <p><strong>{t("MOVES")}: </strong></p><ul>{moves}</ul>
            <ItemDrops level={props.data.MaxRank} bonus={props.data.BonusTableID} drops={props.data.DropTableID} bonusTables={props.bonus} dropTables={props.drops} />
        </div>
        );
};

export default MonDetail;

/**
 * Priority:
 * - None
 * - When Shields Triggered 	
 * - Last move for that turn 
 * - Second move for that turn
 */